import React from "react";
import PropTypes from "prop-types";

import { FormattedMessage, injectIntl } from "react-intl";

import DisabledOverlay from "../grundelemente/DisabledOverlay";

import ApplyDismiss from "./ApplyDismiss";
import { saveSettings } from "./SaveSettings";
import { stateFromModel, modelFromLocal, changeState, recheckState } from "./SettingsValue";
import RightsUser from "./RightsUser";

import "./Rights.css";

const default_local = {
	demo: {
		overview: true,
		analytics: true,
		energy_balancing: true,
		maintenance: false,
		errors: false,
		settings: false
	},
	read: {
		overview: true,
		analytics: true,
		energy_balancing: true,
		maintenance: true,
		errors: true,
		settings: false
	}
};

class Rights extends React.Component {

	static propTypes = {
		rights: PropTypes.object.isRequired,
		auth: PropTypes.object.isRequired
	};

	constructor(props, context) {
		super(props, context);
		this.handleChange = this.handleChange.bind(this);
		this.apply = this.apply.bind(this);
		this.dismiss = this.dismiss.bind(this);
		this.state = this.genState();
	}
	genState() { return stateFromModel(default_local, this.props.rights, Rights.validate); }
	apply() {
		let value = modelFromLocal(this.state.local);
		saveSettings("rights", value);
	}
	dismiss() {
		this.setState(this.genState());
	}
	static validate(local) {
		/*
		 * zumindest hier muss man wenig vlaidieren, bools sind halt bools
		 *
		const number_props = [ "electricity_rate", "electricity_co2_equivalent",
			"oil_price", "oil_heating_value", "oil_co2_equivalent", "gas_price",
			"gas_heating_value", "gas_co2_equivalent" ];
		for (let prop of number_props) {
			if (!isOk(validateNumber(local, prop))) {
				return false;
			}
		}
		*/
		return true;
	}
	handleChange(e, prefix = "") {
		this.setState(changeState(prefix + e.target.name, e.target.value, this.state, Rights.validate));
	}
	componentWillReceiveProps(nextProps) {
		let change = recheckState(this.state, nextProps.rights, Rights.validate);
		if (change) {
			this.setState(change);
		}
	}
	render() {
		return (
			<div className="Rights">
				<DisabledOverlay disabled={!this.props.auth.canWrite} />
				<div className="Parameter">
					<div
						className="control-label user-head">
						<FormattedMessage id="Rights Demo access"/>
					</div>
					<RightsUser user={this.state.local.demo}
						handleChange={e => this.handleChange(e, "demo.")} />
					<div
						className="control-label user-head">
						<FormattedMessage id="Rights Read access"/>
					</div>
					<RightsUser user={this.state.local.read}
						handleChange={e => this.handleChange(e, "read.")} />
				</div>
				<ApplyDismiss state={this.state} apply={this.apply} dismiss={this.dismiss} />
			</div>
		);
	}
}

export default injectIntl(Rights);
